import { useRef } from 'react';

import { FormattedMessage } from '@flipster/i18n';
import { observeIntersectionOnce, useIntersection } from '@flipster/react/misc/browser/intersection';
import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';
import segment from '@flipster/utils/segment';
import { CompetitionsEvent } from '@flipster/utils/segment/events/competitions';

import { MDRenderer } from './md-renderer/MDRenderer';

interface RulesProps {
  markdown: string;
}
export const Rules = ({ markdown }: RulesProps) => {
  const ref = useRef<HTMLDivElement>(null);
  useIntersection(
    ref,
    observeIntersectionOnce(() => {
      segment.track(CompetitionsEvent.CompetitionLandingViewPageScroll, {
        section_title: 'Rules',
      });
    }),
  );
  return (
    <section
      ref={ref}
      className={stack({
        gap: 16,
        m: {
          base: '30px 16px',
          tablet: '60px auto',
        },
        tablet: {
          maxW: 'desktopMaxWidth',
          px: 16,
          boxSizing: 'content-box',
        },
      })}
    >
      <h2 className={css({ textStyle: 'Title/M' })}>
        <FormattedMessage id='Autogen_common.r251126.s_Rules' />
      </h2>
      <MDRenderer
        content={markdown}
        className={css({
          bgColor: 'gray.25',
          rounded: 8,
          p: 16,
          '& > div': {
            '& > *:last-child': { mb: '0px!' },
          },
        })}
      />
    </section>
  );
};
